import { render } from "./LaputaVideoBanner.vue?vue&type=template&id=3ef34b9c&scoped=true"
import script from "./LaputaVideoBanner.vue?vue&type=script&lang=js"
export * from "./LaputaVideoBanner.vue?vue&type=script&lang=js"

import "./LaputaVideoBanner.vue?vue&type=style&index=0&id=3ef34b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef34b9c"]])

export default __exports__